import { RefObject, useEffect, useState } from 'react'

const TIMELINE_STATUS_BOTTOM_PADDING = 32

// calculates height to the bottom of the viewport available for the timeline when data loading stops,
//  allows scrollable timeline in case of overflow
interface UseTimelineStatusMaxHeightProps {
  isLoading: boolean
  ref: RefObject<HTMLDivElement>
}

export const useTimelineStatusMaxHeight = ({ isLoading, ref }: UseTimelineStatusMaxHeightProps) => {
  const [maxHeight, setMaxHeight] = useState<number | undefined>()

  useEffect(() => {
    const updateHeight = () => {
      if (ref.current && !isLoading) {
        const top = ref.current.getBoundingClientRect().top
        const remaining = window.innerHeight - top - TIMELINE_STATUS_BOTTOM_PADDING
        setMaxHeight(remaining)
      }
    }

    updateHeight()

    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [isLoading, ref])

  return { maxHeight }
}
